import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <main className="app-message">
    <h1>Page not found</h1>
    <p>The page you requested does not exist or is no longer available.</p>
    <Link className="btn btn-primary" to="/dashboard">Return to dashboard</Link>
  </main>
);

export default NotFound;
